import React, { PropTypes } from 'react';
import { Field, reduxForm } from 'redux-form';
import { isUndefinedNullOrEmpty } from '../../../js/utils';
import selectionElementMode from '../selectionElementMode';
import FormErrorNotification from '../FormErrorNotification';
import { InputFieldWithValidation } from '../FormComponents';
import InlineValidationMessage from '../InlineValidationMessage';
import SqlServerInstanceSelection from '../SqlServerInstanceSelection';
import LoaderWithText from '../LoaderWithText';

const renderServerSelectionField = (props) => {
    return <div>
        <SqlServerInstanceSelection labelText="SQL Server Instance" value={props.input.value} onChange={props.input.onChange} onModeChanged={props.onModeChanged} />
        <InlineValidationMessage touched={props.meta.touched} error={props.meta.error} />
        <p className="small">Choose a SQL Server that can access the backup files to temporarily restore them during image creation.<br />
        The images can be used to create clones on SQL Server instances of this version or newer.</p>
    </div>;
};

export default (formName, validate) => {
    const BackupLocationForm = React.createClass({
        propTypes: {
            actionName: PropTypes.string.isRequired,
            onValid: PropTypes.func,
            onCancel: PropTypes.func
        },
        getInitialState: function() {
            return {
                isOnSqlServerInstanceAddMode: false
            };
        },
        onSqlServerInstanceSelectionModeChanged: function(mode) {
            this.setState({ isOnSqlServerInstanceAddMode: mode === selectionElementMode.add });
        },
        render: function() {
            const { handleSubmit, onValid, submitting, pristine, error, initialValues, actionName, onCancel } = this.props;
            const { isOnSqlServerInstanceAddMode } = this.state;
            const isFileShareLocationDisabled = !isUndefinedNullOrEmpty(initialValues) && !isUndefinedNullOrEmpty(initialValues.fileShareLocation);

            return <div>
                <FormErrorNotification error={error} />

                {(!isOnSqlServerInstanceAddMode && isFileShareLocationDisabled) && <div className="control-holder">
                    <label>Path to folder</label>
                    <input type="text" value={initialValues.fileShareLocation} disabled />
                </div>}

                {(!isOnSqlServerInstanceAddMode && !isFileShareLocationDisabled) && <div>
                    <h2>Add new backup location</h2>

                    <div className="control-holder">
                        <Field name="fileShareLocation" type="text" label="Path to folder" placeholder="e.g. \\EXAMPLE-NETWORK\share1" autoFocus component={InputFieldWithValidation} />
                        <p className="small">For network locations, use the full network UNC path (starting '\\') rather than a mapped network drive</p>
                    </div>
                </div>}

                <div className="control-holder">
                    <Field name="associatedSqlServerInstance" onModeChanged={this.onSqlServerInstanceSelectionModeChanged} component={renderServerSelectionField} />
                </div>

                {!isOnSqlServerInstanceAddMode && <div className="button-holder">
                    <button className="button button--primary" disabled={pristine || submitting} onClick={handleSubmit(onValid)}>
                        {actionName}
                    </button>
                    <button className="nobutton button--flat-secondary" disabled={submitting} onClick={onCancel}>
                        Cancel
                    </button>
                </div>}

                {submitting && <div className="control-holder">
                    <LoaderWithText loadingText="Validating backup location" />
                </div>}
            </div>;
        }
    });

    return reduxForm({ form: formName, validate })(BackupLocationForm);
};



// WEBPACK FOOTER //
// ./src/components/common/BackupLocationSelection/BackupLocationForm.jsx